import { TableCardProps } from '@/renderer/types/sales';
import { Printer } from 'lucide-react';
import React from 'react';
import { ONBOARDING_TOUR_TARGETS } from '../../services/onboardingTourService';

export const TableCard: React.FC<TableCardProps> = ({
  tableName,
  billNumber,
  isBillPrinted = false,
  isTourPrimary = false,
  isSelected,
  onClick,
  disabled = false,
  title,
}) => {
  return (
    <button
      type="button"
      data-onboarding-tour={
        isTourPrimary ? ONBOARDING_TOUR_TARGETS.salesPrimaryTable : undefined
      }
      className={`flex min-h-[60px] w-full flex-col items-center justify-center gap-1 rounded-md border px-3 py-2 text-center transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${
        isSelected
          ? 'border-primary bg-primary ring-1 ring-primary'
          : billNumber!!
            ? 'border-primary/40 bg-white shadow-[0_0_0_1px_rgba(59,130,246,0.25)]'
            : disabled
              ? 'cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400 opacity-70'
              : 'border-gray-200 bg-white hover:border-gray-300'
      }`}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      <span
        className={`max-w-full truncate text-sm uppercase tracking-wide ${
          isSelected ? 'text-white' : disabled ? 'text-gray-400' : 'text-black'
        }`}
      >
        {tableName}
      </span>
      {billNumber && (
        <span
          className={`flex items-center gap-1 text-xs text-gray-500 ${isSelected ? 'text-white' : ''}`}
        >
          #{billNumber}
          {isBillPrinted && (
            <Printer
              size={12}
              className={isSelected ? 'text-white' : 'text-pos-primary'}
              aria-label="Bill printed"
            />
          )}
        </span>
      )}
    </button>
  );
};
